export default {
    jobs() {
        return window.axios.get('/api/charts/jobs');
    },

    customers() {
        return window.axios.get('/api/charts/customers');
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/ChartsService.js